<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ к Landing</div>
    <div class="markup__h markup__h_3">
      При клике на формат <router-link to="/mobile/mobileNativeUnit" target="_blank" class="link">Mobile Native Unit</router-link> не осуществляется переход на сайт, а открывается сайт внутри сайта – Landing.
    </div>
    <br>
    <router-link to="/mobile/landing" target="_blank" class="link">Демо формата</router-link>
    <br><br>
    <div class="markup__h markup__h_3">Мы создаем внешний вида Landing, ориентируясь на пожелания клиента.</div>
    <br>
    <div class="markup__h markup__h_3">
      <strong>Для разработки нам потребуются материалы:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Логотип бренда на прозрачном фоне, формат: PNG, cоотношение сторон: 1:1, размер: ширина 200px</li>
      <li>Макет страницы (в том числе изображения для статьи в высоком разрешении, текст для статьи, расположение блоков, кнопок и т. п.), формат: PSD / FIGMA / AI, размер: ширина от 1000px</li>
    </ul>

    <div class="markup__h markup__h_3">
      <strong>Опционально:</strong>
    </div>
    <p>При отсутствии материалов по ТТ, описанном выше, для сборки креатива необходимо предоставить тексты и изображения, логотип, фирменные шрифты, Brandbook (в том числе пожелания по цветовому оформлению), а также подробные пожелания по наполнению страницы, расположению блоков</p>

    <marked-zone-atention></marked-zone-atention>
  </div>
</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'landing',
  components: {
    markedZoneAtention,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
